//
// locale_hy.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/hy.json';
import localeData from "react-intl/locale-data/hy.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
